import ActionNode from './ActionNode'

function setText(data) {
  let isShowPostFix = data.emails.length >= 2
  let postFixText = isShowPostFix
    ? `${data.emails.length - 1} and more`
    : ''

  return `Notify ${data.emails[0] || 'none'} ${postFixText}`
}

class ActionNodeNotification extends ActionNode {
  constructor(model) {
    super(model)
    this.text = this.text.includes('Notify')
      ? this.text
      : setText(this.value)
    this.icon = {
      ...this.icon,
      name: 'bell'
    }
  }

  changeValue(value) {
    this.value = value
    this.text = setText(value)
  }
}

export default ActionNodeNotification



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeNotification.js